/*
 * infoList.tsx
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-13 15:12:28
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Collapse, Tooltip, message } from 'antd';
import { Empty, Icon, Tabs } from '@kdcloudjs/kdesign';
import classNames from 'classnames';
import Loading from 'components/loading';
import utilStyles from 'components/util.less';
import { inputTypeRules } from 'components/util/util';
import { generateImportData } from 'helpers/dataHelper';
import { TAB_BAR } from 'components/setter/types';
import EditableTable from 'components/editableTable';
import ErrorList from 'components/errorList';
// import keyJson from 'components/util/key.json';
import positionStyles from 'components/position.less';
import { useSelector } from 'store/hook/useSelector';
import { outputMsg } from 'store/actioin/action';
import { PutAway_svg } from 'image/index';
import Icons from 'Icon/Icons.less';
import llmSvg from 'Icon/svg/llm.svg';
import { HighConfidence_png, LowConfidence_png, MiddleConfidence_png, Edited_png, } from 'image/index';
import Styles from './index.less';
var Panel = Collapse.Panel;
function Header() {
    return (React.createElement("div", { className: Styles.header },
        React.createElement("div", { className: Styles['header-left'] }, "\u9884\u7F6E\u5B57\u6BB5"),
        React.createElement("div", { className: Styles['header-right'] },
            "\u7F6E\u4FE1\u5EA6",
            React.createElement(Tooltip, { arrowPointAtCenter: true, destroyTooltipOnHide: true, placement: "bottomRight", overlayClassName: "header-right-tips", title: React.createElement("div", null,
                    "\u9884\u7F6E\u5B57\u6BB5\u4F7F\u7528\u6A21\u7248\u8FDB\u884C\u8BAD\u7EC3\u548C\u63D0\u53D6\uFF0C\u63D0\u53D6\u4FE1\u606F\u7F6E\u4FE1\u5EA6\u5982\u4E0B",
                    React.createElement("div", { className: "header-right-tips-content" },
                        React.createElement("div", null,
                            React.createElement("img", { src: LowConfidence_png }),
                            "0%~90%"),
                        React.createElement("div", null,
                            React.createElement("img", { src: MiddleConfidence_png }),
                            "90%~95%"),
                        React.createElement("div", null,
                            React.createElement("img", { src: HighConfidence_png }),
                            "95%~100%"))) },
                React.createElement(Icon, { type: "tips" })))));
}
function LlmHeader() {
    return (React.createElement("div", { className: Styles.llmHeader },
        React.createElement("div", { className: Styles.llmHeaderText }, "\u5927\u6A21\u578B\u5B57\u6BB5"),
        React.createElement(Tooltip, { placement: "right", title: "AI\u8BC6\u522B\u5185\u5BB9\u53EF\u80FD\u6709\u8BEF\uFF0C\u8BF7\u7ED3\u5408\u7ECF\u9A8C\u4F7F\u7528", overlayClassName: "llm-header-left-tips" },
            React.createElement("img", { className: Styles.llmSvg, src: llmSvg }))));
}
var InfoList = function (props) {
    var _a;
    var handleSelectListItem = props.handleSelectListItem;
    var _b = useSelector(function (state) { return state; }), hiddenList = _b.control.hiddenList, viewType = _b.global.viewType, extract = _b.data.extract;
    var selectId = extract.selectId, clickShape = extract.clickShape, status = extract.status, taskId = extract.taskId, _c = extract.data, drawJson = _c.drawJson, extractSeq = _c.extractSeq, listJson = _c.listJson, tableJson = _c.tableJson, tableListJson = _c.tableListJson, _d = _c.llmSeq, llmSeq = _d === void 0 ? [] : _d, _e = _c.llmTableJson, llmTableJson = _e === void 0 ? [] : _e, _f = _c.llmTableListJson, llmTableListJson = _f === void 0 ? {} : _f;
    console.log('infoList:', props);
    var keyJson = __spreadArray(__spreadArray([], extractSeq, true), llmSeq, true).reduce(function (acc, cur) {
        acc[cur.extractNum] = cur.extractFieldName;
        return acc;
    }, {});
    var model = useSelector(function (state) { return state.global.model; });
    var dispatch = useDispatch();
    var _g = useState(''), selectKey = _g[0], setSelectKey = _g[1];
    var infoListRef = useRef(null);
    var _h = useState(TAB_BAR.ALL), page = _h[0], setPage = _h[1];
    var tableSeq = useMemo(function () { return extractSeq.filter(function (seq) { return seq.tableFlag; }); }, [extractSeq]);
    var llmTableSeq = useMemo(function () { return llmSeq.filter(function (seq) { return seq.tableFlag; }); }, [extractSeq]);
    var delDrawJson = function (selectItem) {
        dispatch({
            type: 'setDrawJson',
            payload: drawJson.filter(function (item) { return item.extractId !== selectItem.select; }),
        });
    };
    var rectBlur = function () {
        setSelectKey('');
        dispatch({ type: 'changeSelectId', payload: '' });
    };
    var infoJump = function (ele) {
        var _a;
        var dom = ele;
        var visualArea = {
            top: infoListRef.current.scrollTop,
            bottom: infoListRef.current.scrollTop + infoListRef.current.offsetHeight,
        };
        var eleArea = {
            top: ele.offsetTop,
            bottom: ele.offsetTop + ele.offsetHeight,
        };
        var eleInnerVisual = visualArea.bottom > eleArea.bottom &&
            eleArea.bottom > eleArea.top &&
            eleArea.top > visualArea.top;
        if (dom && !eleInnerVisual) {
            (_a = infoListRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, dom.offsetTop -
                infoListRef.current.offsetHeight / 2 +
                dom.offsetHeight / 2);
        }
    };
    var checkRules = function () {
        var status = true;
        extractSeq.forEach(function (item) {
            var _a;
            var listItem = listJson.find(function (listJsonItem) { return listJsonItem.key === item.extractNum; });
            if (listItem &&
                listItem.value.trim() !== '' &&
                !((_a = inputTypeRules[listItem.inputType]) === null || _a === void 0 ? void 0 : _a.rule.test(listItem.value))) {
                status = false;
            }
        });
        return status;
    };
    var handleTableUnitChange = function (value, data, isLlm) {
        if (isLlm === void 0) { isLlm = false; }
        console.log(value, data, isLlm);
        if (!isLlm) {
            // deepClone
            var newTableInfo = JSON.parse(JSON.stringify(tableListJson));
            // const value = event.target.value;
            var tableKey = data.tableKey, tableLineIndex = data.tableLineIndex, lineKey = data.lineKey;
            var unitData = newTableInfo[tableKey].tableData[tableLineIndex].tableLineData[lineKey];
            if (data.selectType === 'tableJson') {
                var newTableJson = tableJson.map(function (item) {
                    if (item.extractId === data.select) {
                        return __assign(__assign({}, item), { hidden: true });
                    }
                    else {
                        return item;
                    }
                });
                dispatch({
                    type: 'hiddenTableUnit',
                    payload: newTableJson,
                });
            }
            if (data.selectType === 'drawJson') {
                var newDrawJson = drawJson.filter(function (item) {
                    return item.extractId !== data.select;
                });
                dispatch({
                    type: 'setDrawJson',
                    payload: newDrawJson,
                });
            }
            unitData.value = value;
            unitData.confidence = null;
            unitData.select = null;
            unitData.selectType === 'input';
            unitData.drawData = [];
            dispatch({
                type: 'setTableInfo',
                payload: newTableInfo,
            });
        }
        else {
            // deepClone
            var newLlmTableInfo = JSON.parse(JSON.stringify(llmTableListJson));
            // const value = event.target.value;
            var tableKey = data.tableKey, tableLineIndex = data.tableLineIndex, lineKey = data.lineKey;
            var unitData = newLlmTableInfo[tableKey].tableData[tableLineIndex].tableLineData[lineKey];
            if (data.selectType === 'tableJson') {
                var newLlmTableJson = llmTableJson.map(function (item) {
                    if (item.extractId === data.select) {
                        return __assign(__assign({}, item), { hidden: true });
                    }
                    else {
                        return item;
                    }
                });
                dispatch({
                    type: 'hiddenLlmTableUnit',
                    payload: newLlmTableJson,
                });
            }
            if (data.selectType === 'drawJson') {
                var newDrawJson = drawJson.filter(function (item) {
                    return item.extractId !== data.select;
                });
                dispatch({
                    type: 'setDrawJson',
                    payload: newDrawJson,
                });
            }
            unitData.value = value;
            unitData.confidence = null;
            unitData.select = null;
            unitData.selectType === 'input';
            unitData.drawData = [];
            dispatch({
                type: 'setLlmTableInfo',
                payload: newLlmTableInfo,
            });
        }
    };
    var selectTable = function (data) {
        if (data.select && data.selectType === 'tableJson') {
            dispatch({
                type: 'changeSelectId',
                payload: data.select,
            });
        }
        if (data.select && data.selectType === 'drawJson') {
            dispatch({
                type: 'changeSelectId',
                payload: data.select,
            });
        }
    };
    var normalEle = function () {
        // if (!extractSeq.length) {
        //   return <Empty />;
        // }
        return (React.createElement(React.Fragment, null, extractSeq.map(function (item) {
            var listItem = listJson.find(function (listJsonItem) { return listJsonItem.key === item.extractNum; });
            if (listItem) {
                return (React.createElement(ListItemSelection, { keyJson: keyJson, selectId: selectId, onSelectListItem: handleSelectListItem, key: item.extractNum, selectKey: selectKey, handleJump: infoJump, clickShape: clickShape, setSelectKey: setSelectKey, delDrawJson: delDrawJson, listItem: listJson.find(function (listJsonItem) { return listJsonItem.key === item.extractNum; }) }));
            }
            else {
                return null;
            }
        })));
    };
    var tableEle = function () {
        // 找出所有表格字段
        // const tableSeq = extractSeq.filter(seq => seq.tableFlag);
        // if (!tableSeq.length) {
        //   return <Empty />;
        // }
        // 在所有表格字段中按照tableNum进行分类
        var tables = tableSeq.reduce(function (acc, cur) {
            if (Array.isArray(acc[cur.tableNum])) {
                acc[cur.tableNum].push(cur);
            }
            else {
                acc[cur.tableNum] = [cur];
            }
            return acc;
        }, {});
        // 组装表格数据
        var dataSource = Object.keys(tables).map(function (tablesKey) {
            var _a;
            var tableDatasource = [];
            // 表头数据
            var table = tables[tablesKey];
            tableDatasource.push(table);
            // 表体数据
            var tableData = (_a = tableListJson === null || tableListJson === void 0 ? void 0 : tableListJson[tablesKey]) === null || _a === void 0 ? void 0 : _a.tableData;
            var tableBody = tableData === null || tableData === void 0 ? void 0 : tableData.map(function (tableDataItem) {
                var tableLineData = tableDataItem.tableLineData, tableLineIndex = tableDataItem.tableLineIndex;
                var tempArr = [];
                // 按照表头顺序给每行表体数据排序
                table.forEach(function (t) {
                    // tableLineData[t.extractNum] &&
                    tempArr.push(tableLineData[t.extractNum] || {});
                });
                return tempArr;
            });
            tableDatasource.push.apply(tableDatasource, tableBody);
            return tableDatasource;
        });
        return (React.createElement(React.Fragment, null, dataSource.map(function (d, i) {
            var _a;
            return (React.createElement(EditableTable, { key: "".concat(i), tableName: (_a = d[0]) === null || _a === void 0 ? void 0 : _a.tableName, dataSource: d, onChange: function (value, cell) {
                    handleTableUnitChange(value, cell);
                }, onSelect: selectTable }));
        })));
        // const tableMap = new Map();
        // tableSeq.forEach(seq => {
        //   if (tableMap.has(seq.tableNum)) {
        //     tableMap.set(seq.tableNum, tableMap.get(seq.tableNum).concat(seq));
        //   } else {
        //     tableMap.set(seq.tableNum, [seq]);
        //   }
        // });
        // const tableArr = Array.from(tableMap);
        // const tableInfo = tableListJson;
        // return tableArr.map((tableItem, index) => {
        //   const tableKey = tableItem[0];
        //   const tableLines = tableItem[1];
        //   const tableDataByKey = tableInfo[tableKey];
        //   if (tableDataByKey) {
        //     const { tableId, tableData } = tableInfo[tableKey];
        //     const tableHead = (
        //       <tr className={Styles.tableLine}>
        //         <td className={Styles.tableTitle}>字段名称</td>
        //         {tableLines.map(lineSeq => {
        //           return (
        //             <td className={Styles.tableUnit} key={lineSeq.extractNum}>
        //               {lineSeq.extractFieldName}
        //             </td>
        //           );
        //         })}
        //       </tr>
        //     );
        //     const tableLine = tableData.map(tableLine => {
        //       const { tableLineIndex, tableLineData } = tableLine;
        //       return (
        //         <tr
        //           className={Styles.tableLine}
        //           key={`${`tableId` + 'Line'}${tableLineIndex}`}
        //         >
        //           <td className={Styles.tableUnit}>数值{tableLineIndex + 1}</td>
        //           {tableLines.map(lineSeq => {
        //             const data = tableLineData[lineSeq.extractNum];
        //             return (
        //               <td
        //                 onMouseMove={() => {
        //                   selectTable(data);
        //                 }}
        //                 className={Styles.tableUnit}
        //                 key={lineSeq.extractNum}
        //               >
        //                 <input
        //                   value={data.value}
        //                   onChange={e => handleTableUnitChange(e, data)}
        //                 />
        //               </td>
        //             );
        //           })}
        //         </tr>
        //       );
        //     });
        //     return (
        //       <div className={Styles.tableArea} key={tableId}>
        //         <table
        //           border={1}
        //           cellPadding={0}
        //           cellSpacing={0}
        //           className={Styles.tableInfo}
        //         >
        //           <thead>{tableHead}</thead>
        //           <tbody>{tableLine}</tbody>
        //         </table>
        //       </div>
        //     );
        //   } else {
        //     return null;
        //   }
        // });
    };
    var llmNormalEle = function () {
        // if (!llmSeq.length) {
        //   return <Empty />;
        // }
        return (React.createElement(React.Fragment, null, llmSeq === null || llmSeq === void 0 ? void 0 : llmSeq.map(function (item) {
            var listItem = listJson.find(function (listJsonItem) { return listJsonItem.key === item.extractNum; });
            if (listItem) {
                return (React.createElement(ListItemSelection, { keyJson: keyJson, selectId: selectId, onSelectListItem: handleSelectListItem, key: item.extractNum, selectKey: selectKey, handleJump: infoJump, clickShape: clickShape, setSelectKey: setSelectKey, delDrawJson: delDrawJson, listItem: listItem }));
            }
            else {
                return null;
            }
        })));
    };
    var llmTableEle = function () {
        // 找出所有表格字段
        // const llmTableSeq = llmSeq.filter(seq => seq.tableFlag);
        // if (!llmTableSeq.length) {
        //   return <Empty />;
        // }
        // 在所有表格字段中按照tableNum进行分类
        var tables = llmTableSeq.reduce(function (acc, cur) {
            if (Array.isArray(acc[cur.tableNum])) {
                acc[cur.tableNum].push(cur);
            }
            else {
                acc[cur.tableNum] = [cur];
            }
            return acc;
        }, {});
        // 组装表格数据
        var dataSource = Object.keys(tables).map(function (tablesKey) {
            var _a;
            var tableDatasource = [];
            // 表头数据
            var table = tables[tablesKey];
            tableDatasource.push(table);
            // 表体数据
            var tableData = (_a = llmTableListJson === null || llmTableListJson === void 0 ? void 0 : llmTableListJson[tablesKey]) === null || _a === void 0 ? void 0 : _a.tableData;
            var tableBody = tableData === null || tableData === void 0 ? void 0 : tableData.map(function (tableDataItem) {
                var tableLineData = tableDataItem.tableLineData, tableLineIndex = tableDataItem.tableLineIndex;
                var tempArr = [];
                // 按照表头顺序给每行表体数据排序
                table.forEach(function (t) {
                    // tableLineData[t.extractNum] &&
                    tempArr.push(tableLineData[t.extractNum] || {});
                });
                return tempArr;
            });
            tableDatasource.push.apply(tableDatasource, tableBody);
            return tableDatasource;
        });
        return (React.createElement(React.Fragment, null, dataSource.map(function (d, i) {
            var _a;
            return (React.createElement(EditableTable, { key: "".concat(i), tableName: (_a = d[0]) === null || _a === void 0 ? void 0 : _a.tableName, dataSource: d, onChange: function (value, cell) {
                    handleTableUnitChange(value, cell, true);
                }, onSelect: selectTable }));
        })));
    };
    return (React.createElement("div", { className: classNames(Styles.listArea, (_a = {},
            _a[Styles.hiddenList] = hiddenList,
            _a)) },
        React.createElement("div", { className: classNames(Styles.listNav, positionStyles['between_center']) },
            React.createElement("span", null, "\u4FE1\u606F\u63D0\u53D6\u8BE6\u60C5"),
            React.createElement("img", { onClick: function () { return dispatch({ type: 'changeHiddenList', payload: true }); }, alt: '', style: {
                    width: '18px',
                    cursor: 'pointer',
                    display: status === 'loading' ? 'none' : 'flex',
                }, src: PutAway_svg })),
        status === 'loading' ? React.createElement(Loading, null) : null,
        status === 'error' ? React.createElement(ErrorList, null) : null,
        status === 'success' ? (React.createElement("div", { ref: infoListRef, onMouseLeave: function () { return rectBlur(); }, className: Styles.listBody, style: {
                height: viewType === 'ie_show_task' || viewType === 'ie_test_task'
                    ? 'calc(100% - 50px)'
                    : 'calc(100% - 100px)',
            } },
            React.createElement(Tabs, { type: "card", activeKey: page, onChange: function (key) {
                    setPage(key);
                }, className: Styles.tabs },
                React.createElement(Tabs.TabPane, { key: "all", tab: "\u5168\u90E8\u5B57\u6BB5" },
                    React.createElement("div", { className: Styles.allList }, !extractSeq.length &&
                        !tableSeq.length &&
                        !llmSeq.length &&
                        !llmTableSeq.length ? (React.createElement(Empty, null)) : (React.createElement(Collapse, { ghost: true, defaultActiveKey: ['preset', 'llm'] },
                        extractSeq.length || tableSeq.length ? (React.createElement(Panel, { header: React.createElement(Header, null), key: "preset" },
                            normalEle(),
                            tableEle())) : null,
                        llmSeq.length || llmTableSeq.length ? (React.createElement(Panel, { header: React.createElement(LlmHeader, null), key: "llm" },
                            llmNormalEle(),
                            llmTableEle())) : null)))),
                React.createElement(Tabs.TabPane, { key: "normal", tab: "\u666E\u901A\u5B57\u6BB5" },
                    React.createElement("div", { className: Styles.normalList }, !extractSeq.filter(function (i) { return !i.tableFlag; }).length &&
                        !llmSeq.filter(function (i) { return !i.tableFlag; }).length ? (React.createElement(Empty, null)) : (React.createElement(Collapse, { ghost: true, defaultActiveKey: ['preset', 'llm'] },
                        extractSeq.filter(function (i) { return !i.tableFlag; }).length ? (React.createElement(Panel, { header: React.createElement(Header, null), key: "preset" }, normalEle())) : null,
                        llmSeq.filter(function (i) { return !i.tableFlag; }).length ? (React.createElement(Panel, { header: React.createElement(LlmHeader, null), key: "llm" }, llmNormalEle())) : null)))),
                React.createElement(Tabs.TabPane, { key: "table", tab: "\u8868\u683C\u5B57\u6BB5" },
                    React.createElement("div", { className: Styles.tableList }, !tableSeq.length && !llmTableSeq.length ? (React.createElement(Empty, null)) : (React.createElement(Collapse, { ghost: true, defaultActiveKey: ['preset', 'llm'] },
                        tableSeq.length ? (React.createElement(Panel, { header: React.createElement(Header, null), key: "preset" }, tableEle())) : null,
                        llmTableSeq.length ? (React.createElement(Panel, { header: React.createElement(LlmHeader, null), key: "llm" }, llmTableEle())) : null))))))) : null,
        React.createElement("div", { style: {
                display: viewType === 'ie_show_task' || viewType === 'ie_test_task'
                    ? 'none'
                    : 'flex',
            }, className: classNames(Styles.listFooter, positionStyles['inTheMiddle']) }, status === 'loading' ? (React.createElement(React.Fragment, null,
            React.createElement("button", { onClick: function () {
                    model.invokeAsync('cancelExtract', {
                        taskId: taskId,
                        // fid: "",
                    });
                    dispatch({ type: 'backHomePage', payload: 'backHomePage' });
                }, className: Styles.cancel, style: {
                    display: !taskId ? 'none' : 'block',
                } }, "\u53D6\u6D88\u4EFB\u52A1"),
            React.createElement("button", { onClick: function () {
                    dispatch({ type: 'backHomePage', payload: 'backHomePage' });
                }, className: Styles.backRun }, "\u540E\u53F0\u8FD0\u884C"))) : status === 'success' ? (React.createElement(React.Fragment, null,
            React.createElement("button", { onClick: function () {
                    model.invokeAsync('saveExtractInfo', {
                        taskId: taskId,
                        updateData: JSON.stringify(__assign({}, extract)),
                    });
                }, className: Styles.save }, "\u4FDD\u5B58"),
            React.createElement("button", { onClick: function () {
                    if (checkRules()) {
                        var importData = generateImportData(extract);
                        model.invokeAsync('importExtractInfo', importData);
                    }
                    else {
                        dispatch(outputMsg('输入内容不符合格式要求，请重新输入。'));
                    }
                }, className: Styles.importDoc }, "\u5BFC\u5165\u5355\u636E"))) : null)));
};
var ListItemSelection = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g, _h;
    // inputType
    // 通用文本	1
    // 纯数字	2
    // 邮箱	3
    // 小写金额	4
    // 大写金额	5
    // 公司名称	6
    // 姓名	7
    // 银行	8
    // 地址	9
    // 数字/英文	10
    // 日期	11
    // 币种	12
    // 电话号码	13
    var selectRef = useRef(null);
    var infoItemRef = useRef(null);
    var _j = useState(false), twinkle = _j[0], setTwinkle = _j[1];
    useEffect(function () {
        document.addEventListener('mousedown', function (e) {
            var _a;
            var target = e.target;
            if (!((_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                setShowOption(false);
            }
        });
    }, []);
    useEffect(function () {
        if (props.clickShape.id === props.listItem.select) {
            props.setSelectKey(props.listItem.key);
            props.handleJump(infoItemRef.current);
            setTwinkle(true);
            setTimeout(function () {
                setTwinkle(false);
            }, 1050);
        }
        else if (props.clickShape.id === '') {
            props.setSelectKey('');
        }
    }, [props.clickShape]);
    var inputRef = useRef(null);
    var wordSelection = useSelector(function (state) { return state.data.extract.wordSelection; });
    var dispatch = useDispatch();
    var model = useSelector(function (state) { return state.global.model; });
    var _k = useState(false), showOption = _k[0], setShowOption = _k[1];
    var handleChangeInput = function (e) {
        if (props.listItem.selectType === 'drawJson') {
            props.delDrawJson(props.listItem);
        }
        dispatch({ type: 'changeSelectId', payload: '' });
        dispatch({
            type: 'listJsonSelect',
            payload: {
                value: e.target.value,
                drawData: [],
                select: null,
                selectType: 'input',
                key: props.listItem.key,
                confidence: null,
            },
        });
    };
    var getJSDocImplementsTags = function (item) {
        var confidence = item.confidence;
        // 大模型提取不现实置信度
        if (item.isLlm) {
            if (confidence === null) {
                return Edited_png;
            }
            else {
                return '';
            }
        }
        // 预制字段
        if (!item.isLlm) {
            if (confidence === null) {
                return Edited_png;
            }
            else if (confidence <= 0.9 && confidence >= 0) {
                return LowConfidence_png;
            }
            else if (confidence > 0.9 && confidence <= 0.95) {
                return MiddleConfidence_png;
            }
            else if (confidence > 0.95 && confidence <= 1) {
                return HighConfidence_png;
            }
        }
    };
    var rectFocus = function () {
        props.setSelectKey(props.listItem.key);
        if (props.listItem.select && props.listItem.select !== props.selectId) {
            dispatch({ type: 'changeSelectId', payload: props.listItem.select });
        }
    };
    var getOperationIcons = function (key, type) {
        if (key === 'tax_rate') {
            return (React.createElement("span", { className: (utilStyles.unSelect, utilStyles.unDrag) }, "%"));
        }
        else if (type === '12') {
            return (React.createElement("span", { className: classNames(Icons['icon-money'], Styles.iconBtn), onClick: function () {
                    model.invokeAsync('showF7', {
                        type: 'currency',
                    });
                } }));
        }
        else {
            return null;
        }
    };
    return (React.createElement("div", { ref: infoItemRef, onMouseMove: function () { return rectFocus(); }, onClick: function () {
            if (props.listItem.isLlm) {
                message.warning('大模型字段暂不支持定位');
            }
            if (wordSelection.show) {
                dispatch({
                    type: 'setWordSelection',
                    payload: __assign(__assign({}, wordSelection), { type: 'normal', field: props.listItem.key }),
                });
            }
            else {
                if (props.listItem.select) {
                    props.onSelectListItem(props.listItem.select, props.listItem.selectType);
                }
            }
        }, className: classNames(Styles.listItem, (_a = {}, _a[Styles.listSelected] = props.listItem.key === props.selectKey, _a), (_b = {}, _b[Styles.twinkle] = twinkle, _b), positionStyles['around_center']) },
        React.createElement("div", { className: classNames(Styles.listItemTitle, positionStyles['start_center']) },
            props.listItem.value !== '' ? (React.createElement("img", { src: getJSDocImplementsTags(props.listItem) })) : (React.createElement("div", { className: Styles.whiteSpaceHold })),
            props.keyJson[props.listItem.key]),
        React.createElement("div", { className: classNames((_c = {},
                _c[Styles.verifyFailed] = props.listItem.value.trim() !== '' &&
                    !((_g = inputTypeRules[props.listItem.inputType]) === null || _g === void 0 ? void 0 : _g.rule.test(props.listItem.value)),
                _c), Styles.listItemSelection, positionStyles['inTheMiddle']) },
            React.createElement("input", { ref: inputRef, onFocus: function () { return rectFocus(); }, onChange: function (e) { return handleChangeInput(e); }, type: 'text', 
                // readOnly={props.listItem.inputType === "11"}
                placeholder: (_h = inputTypeRules[props.listItem.inputType]) === null || _h === void 0 ? void 0 : _h.placeholder, value: props.listItem.value }),
            getOperationIcons(props.listItem.key, props.listItem.inputType),
            props.listItem.data.length > 1 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classNames(Styles.selectionBtn, (_d = {}, _d[Icons['icon-up']] = showOption, _d), (_e = {}, _e[Icons['icon-down']] = !showOption, _e)), onClick: function () { return setShowOption(!showOption); } }),
                React.createElement("div", { style: { display: showOption ? 'flex' : 'none' }, ref: selectRef, className: classNames(Styles.optionList) }, props.listItem.data.map(function (listItemData) {
                    var _a;
                    return (React.createElement("div", { className: classNames(Styles.option, (_a = {},
                            _a[Styles.optionSelect] = props.listItem.select === listItemData.extractId,
                            _a), positionStyles['start_center'], utilStyles['unSelect']), key: listItemData.extractId, onClick: function () {
                            setTimeout(function () {
                                props.onSelectListItem(listItemData.extractId, listItemData.type);
                            }, 200);
                            if (props.listItem.selectType === 'drawJson') {
                                props.delDrawJson(props.listItem);
                            }
                            dispatch({
                                type: 'changeSelectId',
                                payload: listItemData.extractId,
                            });
                            dispatch({
                                type: 'listJsonSelect',
                                payload: {
                                    value: listItemData.infoText,
                                    select: listItemData.extractId,
                                    selectType: listItemData.type,
                                    key: props.listItem.key,
                                    confidence: listItemData.confidence,
                                },
                            });
                            setShowOption(false);
                            inputRef.current.focus();
                        } }, listItemData.infoText));
                })))) : (React.createElement("div", { style: {
                    display: props.listItem.confidence === null &&
                        props.listItem.data.length > 0
                        ? 'flex'
                        : 'none',
                }, className: classNames(Styles.selectionBtn, (_f = {},
                    _f[Icons['icon-flash']] = true,
                    _f)), onClick: function (e) {
                    e.stopPropagation();
                    if (props.listItem.selectType === 'drawJson') {
                        props.delDrawJson(props.listItem);
                    }
                    dispatch({
                        type: 'changeSelectId',
                        payload: props.listItem.data[0].extractId,
                    });
                    dispatch({
                        type: 'listJsonSelect',
                        payload: {
                            value: props.listItem.data[0].infoText,
                            select: props.listItem.data[0].extractId,
                            selectType: props.listItem.data[0].type,
                            key: props.listItem.key,
                            confidence: props.listItem.data[0].confidence,
                        },
                    });
                    inputRef.current.focus();
                } })))));
};
export default connect(function (state) { return state; })(InfoList);
